import clsx from 'clsx';

import { GEAR_CARD_HEIGHT, GEAR_CARD_WIDTH } from '@/modules/players/v3/constants/gear';

interface GearCardSkeletonProps {
  fluid?: boolean;
}

export const GearCardSkeleton = ({ fluid = false }: GearCardSkeletonProps) => {
  return (
    <div
      className={clsx(
        'flex flex-col gap-2 rounded-[13px] border border-gray-200 bg-white p-4 shadow-sm',
        {
          'w-full': fluid,
          'mx-auto md:mx-0': !fluid,
        }
      )}
      style={
        fluid ? { height: GEAR_CARD_HEIGHT } : { width: GEAR_CARD_WIDTH, height: GEAR_CARD_HEIGHT }
      }
    >
      <div className='h-[130px] w-full shrink-0 animate-pulse rounded-md bg-gray-200' />
      <div className='flex min-h-0 flex-1 flex-col gap-1'>
        <div className='h-4 w-full animate-pulse rounded bg-gray-200' />
        <div className='h-4 w-2/3 animate-pulse rounded bg-gray-200' />
      </div>
      <div className='h-9 w-full animate-pulse rounded-md bg-gray-200' />
    </div>
  );
};
